module.exports = __webpack_public_path__ + "../public/img/dose.18315eb9.png";